import React, { FC } from 'react'

import { Txt, Tag } from 'src/components/atoms'

type Props = {
  title: string
  isWorksManaged?: boolean
  className?: string
}

export const ProjectModalTitle: FC<Props> = ({ title, isWorksManaged = true, className }) => {
  return (
    <div className={className}>
      <div className="tw-flex tw-items-center">
        <Txt sizeType="l" className="tw-font-bold tw-text-standardText-primary">
          {title}
        </Txt>
        {!isWorksManaged && (
          <Tag type="secondary" state="outline" className="tw-ml-s1">
            個別契約
          </Tag>
        )}
      </div>
    </div>
  )
}
